import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { DeviceDetectionModule } from '@wdpr/ra-angular-device-detection';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

import { BaymaxHeaderModule } from '../baymax-header/baymax-header.module';
import { DclBaseModalComponent } from './modal/base-modal.component';
import { DclLinkModalComponent } from './link-modal/link-modal.component';
import { DeviceService } from '../device/device.service';
import { LoadingContentModule } from '../loading-content/loading-content.module';
import { ModalService } from './services/modal.service';

@NgModule({
    declarations: [
        DclBaseModalComponent,
        DclLinkModalComponent
    ],
    imports: [
        BaymaxHeaderModule,
        CommonModule,
        DeviceDetectionModule,
        LoadingContentModule,
        MatDialogModule,
        TranslateModule
    ],
    providers: [
        DeviceService,
        ModalService
    ],
    exports: [
        DclBaseModalComponent,
        DclLinkModalComponent,
        MatDialogModule
    ],
    entryComponents: [
        DclBaseModalComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class BaseModalModule { }
